import Base from "./base.js"

export default class AfterApiExec extends Base {
  constructor(Vue, store) {
    super("after-api-exec", Vue, store)
  }

  after(to, from) {
    console.log("api-exec")

    const event = this.store.getters["event/event"]
    const slug = from.params.slug || to.params.slug

    if (!event && event.slug === slug) return

    if (!this.store.getters["corner/all"].length) {
      this.store.dispatch("corner/getCorners", slug)
    }

    if (!this.store.getters["room/all"].length) {
      this.store.dispatch("room/getRooms", slug)
    }

    // ページ遷移した場合はスクロールTopさせる
    if (to.path !== from.path) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }
}
